<m27-dialog #modal class="dialog-stewarded-regcomp-report-criteria-component">
    <m27-dialog-header [showClose]="true" [allowMaxSize]="true" (onClose)="isBackButtonEnabled() ? close('Cancel') : closeAll()">
        <div class="title">
            <span>
                <i class="fa fa-table"></i>
                Stewarded RegComp Report Criteria
            </span>
        </div>
    </m27-dialog-header>
    <m27-dialog-body>
        <m27-page-section [caption]="'Crops:'">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableCrops">
                    <input type="checkbox" automationid="stewardedRegCompCropSearch" [id]="'chkSR' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chkSR' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Years:'">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableYears">
                    <input type="checkbox" automationid="stewardedRegCompYearSearch" [id]="'chkSR' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chkSR' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Permit Countries:'" style="height: 71px;">
            <app-multi-select-dropdown #multidrop style="float: left; display: table" [(selectedCountryList)]="selectedCountryList" [(selectedStateList)]="selectedStateList" [(selectedCountyList)]="selectedCountyList" (childEventCountry)="selectedCountryList=$event" (childEventState)="selectedStateList=$event" (childEventCounty)="selectedCountyList=$event" automationid="regulatedRegCompCountrySearch"></app-multi-select-dropdown>
        </m27-page-section>

        <!--<div class="section">
        <div style="float: left;">
            <div class="header">Crops:</div>
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableCrops">
                    <input type="checkbox" automationid="stewardedRegCompCropSearch" [id]="'chkSR' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chkSR' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </div>
        <div style="float: left;">
            <div class="header">Years:</div>
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableYears">
                    <input type="checkbox" automationid="stewardedRegCompYearSearch" [id]="'chkSR' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chkSR' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </div>
        <div style="float: left;">
            <div class="header">Geography:</div>
            <div class="horizontal-options">
                <app-multi-select-dropdown #multidrop style="float: left; display: table" [(selectedCountryList)]="selectedCountryList" [(selectedStateList)]="selectedStateList" [(selectedCountyList)]="selectedCountyList"
                                           (childEventCountry)="selectedCountryList=$event" (childEventState)="selectedStateList=$event" [maxHeight]=150 (childEventCounty)="selectedCountyList=$event" automationid="stewardedRegCompCountrySearch"></app-multi-select-dropdown>
            </div>
        </div>
    </div>-->

        <m27-page-section [caption]="'Optional Selections:'">
            <m27-input icon="location-pin" [(ngModel)]="locationName" style="width:230px; margin-left: 10px;" automationid="regulatedRegCompLocation">
                Location Name
            </m27-input>
        </m27-page-section>

        <m27-page-section [caption]="'Report Options:'">
            <div class="horizontal-options">
                <span class="radio" *ngFor="let cb of reportItems">
                    <input type="radio" single automationid="stewardedRegCompReportOption" [id]="'chkSR' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="onCheckboxChange($event)" />
                    <label [for]="'chkSR' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </m27-page-section>

    </m27-dialog-body>

    <m27-dialog-footer>
        <div class="dialog-buttons-left">
            <button *ngFor="let btn of leftButtons; let idx = index" automationid="stewardedRegCompBack" class="button" [autofocus]="btn.IsPrimary" [ngClass]="{'primary' : btn.IsPrimary }" (click)="btn.Action()">
                {{btn.Text}}
            </button>
        </div>
        <div class="dialog-buttons-right">
            <div automationid="stewardedRegCompReportIdJustCreated" class="badge warn" *ngIf="showReportJustCreatedBadge">Report {{reportIdJustCreated}} Created</div>
            <button *ngFor="let btn of rightButtons; let idx = index" automationid="stewardedRegCompRunReports" class="button" [autofocus]="btn.IsPrimary" [disabled]="btn.IsDisabled()" [ngClass]="{'primary' : btn.IsPrimary }" (click)="btn.Action()">
                {{btn.Text}}
            </button>
        </div>
    </m27-dialog-footer>
</m27-dialog>
